<template>
<div>
    <v-img :src="require('@/assets/maya/servicios/headers/incomingInspection.jpg')" max-height="420" class="px-3 px-sm-10 pt-6">
        <Topper />

        <v-card flat class="px-4 mt-8 mt-sm-12 pb-2 pb-sm-2 transparent" max-width="850">
            <div class="white--text font-weight-light" :class="($vuetify.breakpoint.xsOnly) ? 'display-1' : 'display-2'">
                Incoming Inspection
            </div>

            <div class="white mt-3" style="height:1px; max-width:420px"></div>

            <div class="mt-4 title white--text font-weight-regular" style="max-width:480px; line-height:1.3">
                <div>Inspección de entrada de mercancías o "Incoming"</div>
            </div>

            <div>
                <v-btn small text class="white--text ml-n4 mt-2" @click="$router.push('/servicios')">
                    <div class="d-flex align-center">
                        <v-icon size="12" color="white" class="mr-2 mt-1">fa-arrow-left</v-icon>
                        <div>Regresar a servicios</div>
                    </div>
                </v-btn>
            </div>
        </v-card>
    </v-img>

    <div class="white py-6 px-4 px-sm-0">
        <v-row class="">
            <v-col cols="12" sm="10" offset-sm="1" md="8" offset-md="1">
                <p>
                    <span class="primary--text font-weight-bold">La inspección de entrada de mercancías o "Incoming"</span> es un servicio mediante el cual llevamos un control de calidad riguroso para todos los envíos de mercancías de proveedores a cliente.  Directamente en planta, detectamos fallas de materiales o componentes antes de ser enviados a almacén o a línea de producción.
                </p>

                <div class="mt-4 primary--text font-weight-bold">Realizamos:</div>
                <ul>
                    <li>Inspecciones visuales y dimensionales.</li>
                    <li>Pruebas funcionales.</li>
                    <li>Conteo de unidades.</li>
                    <li>Revisión de empaques.</li>
                    <li>Inspección al 100% de piezas recibidas.</li>
                    <li>Un método de muestreo que asegure que un lote de material es suficientemente bueno o no, y por qué.</li>
                    <li>Determinamos y calificamos el estándar de calidad para los lotes de material que se reciben.</li>
                </ul>

                <p class="mt-4">
                    Todos los servicios de inspección están basados en los estándares internacionales ISO 9001 - 2015.
                </p>

                <p>
                    Este servicio es de gran importancia para las industrias con las que trabajamos ya que así se minimizan riesgos y costos pues logramos la eliminación de lotes de productos con defectos, que a la vez causarían problemas graves de manufactura o ensamble.
                </p>
            </v-col>
        </v-row>
    </div>

    <!-- CONTACT FORM -->
    <ContactForm />
</div>
</template>

<script>
import ContactForm from '@/components/ContactForm'

export default {
    components: {
        ContactForm
    },
    metaInfo: {
      title: 'Incoming Inspection'
    }
}
</script>
